import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import SearchForm from "../components/SearchForm";
import CocktailList from "../components/CocktailList";

const Cocktails = () => {
  return (
    <div>
      <Navbar />
      <Hero title={"Cocktails"} />
      <SearchForm />
      <CocktailList />
      <Footer />
    </div>
  );
};

export default Cocktails;
